import classNames from "classnames";
import React from "react";
import { t } from "ttag";

import { useAppSelector } from "../../reducers";
import { Step } from "../constants";

interface IProps {
    onEdit?: (event?: React.MouseEvent<HTMLElement>) => void;
}

export const BillingAddressSummary = (props: IProps): React.ReactNode => {
    const form = useAppSelector((state) => state.checkout.form);
    const showSummary = useAppSelector(
        (state) => state.checkout.form.current_step > Step.BILLING_ADDRESS,
    );

    const summaryClasses = classNames({
        "checkout-step__summary": true,
        "checkout-step__summary--collapsed": !showSummary,
    });
    return (
        <div className={summaryClasses}>
            <h3 className="checkout-step__label">{t`Bill to:`}</h3>
            <div className="checkout-step__billing-address">
                {/* TODO(i18n): Hard-coded word order assumption. Name format varies by locale. Use template with interpolation: t`${firstName} ${lastName}` or consider locale-specific name formatting */}
                {form.billing_first_name} {form.billing_last_name}
                <br />
                {form.billing_line1}
                <br />
                {form.billing_line2 ? <div>{form.billing_line2}</div> : null}
                {/* TODO(i18n): Hard-coded address format and punctuation (comma, spaces). Address format varies by country. Consider locale-specific address formatting or use template: t`${city}, ${state} ${postcode}` */}
                {form.billing_line4}, {form.billing_state}{" "}
                {form.billing_postcode}
                <br />
                {form.billing_phone_number}
            </div>
            {props.onEdit && (
                <a
                    className="checkout-step__back"
                    href="#"
                    onClick={props.onEdit}
                >
                    {t`Edit`}
                </a>
            )}
        </div>
    );
};
